import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { breakpoint } from 'utils/mediaQueries';
import SliderTeam from 'components/pages/Qemotion/TeamBlock/Slider/SliderTeam';

const StyledGrid = styled(Grid)`
  overflow: hidden;
  padding: 1rem 0;
  width: 2000px;
  position: absolute;
  top: 3rem;
  ${breakpoint.down('md')`
  display:none`}
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex-wrap: nowrap;
    width: 100%;
    left: 0;
  }
`;
const StyledImg = styled(Img)`
  max-width: 300px;
  width: 100%;
`;
const TeamBlock = ({ images, isMobile }) => {
  if (isMobile) {
    return <SliderTeam images={images} />;
  } else {
    return (
      <StyledGrid container justify="center" alignItems="center" id="teamBlock">
        {images.map((image, index) => (
          <StyledImg
            key={`StyledImg${index}`}
            fluid={image.childImageSharp.fluid}
          />
        ))}
      </StyledGrid>
    );
  }
};

export default TeamBlock;
